<template>
  <div v-if="($store.state.config.boxEnabled && is_mobile_ag()) || $store.state.user.modal_reco_sizeModal"
    id="cleed-container" class="cleed-namespace">
    <div v-if="$store.state.config.boxEnabled && is_mobile_ag()" class="cleed-app" aria-live="polite">
      <div v-if="boxOpened" id="box-frame" class="cleed-box-frame cleed-kyolyo er0v0040 cleed-box-frame-enter-done"
        :style="$store.state.videoChat.screen_sharing
      ? 'width: 850px; height: 479px'
      : ''
    ">
        <i-frame id="cleed-frame" name="cleed-box-frame">
          <AuthFlow v-if="showAuthFlow || showSubsFlow" />
          <box v-else />
        </i-frame>
        <Box_modal />
      </div>
      <chat-circle></chat-circle>
      <div v-show="boxOpened || !popUpClosed">
        <div class="cleed-ytk0w4 e1cisntp0"></div>
      </div>
      <pop-up v-if="!popUpClosed"></pop-up>
    </div>
    <div v-if="$store.state.user.modal_reco_sizeModal" class="modal-size-container">
      <size-recommendation :box-status="$store.state.config.boxEnabled && is_mobile_ag()"
        @close="$store.state.user.modal_reco_sizeModal = false" />
    </div>
  </div>
</template>

<script>
import IFrame from "./components/IFrame.vue";
import Box from "./components/Box.vue";
import AuthFlow from "./components/forms/Auth_Flow";
import PopUp from "./components/PopUp.vue";
import Circle_lexception from "./components/customs/Circle_lexception";
import ChatCircle from "./components/ChatCircle";
import specs from "@/specs";
import utils, { customLogger } from "../src/utils/index";
import SizeRecommendation from "@/components/modal/SizeRecommendation.vue";
import Box_modal from "./components/customs/Box_modal.vue";

const obj = {
  name: "App",
  components: {
    IFrame,
    Box,
    PopUp,
    SizeRecommendation,
    AuthFlow,
    Box_modal
  },
  methods: {
    is_mobile_ag() {
      if (this.$store.state.config.storeId == 18 && utils.isMobile() === true)
        return false;
      return true;
    },
  },
  computed: {
    boxOpened() {
      return this.$store.state.navigation.boxOpened;
    },
    popUpClosed() {
      return this.$store.state.session_navigation.popupClosed;
    },
    showAuthFlow() {
      return this.$store.state.navigation.showAuthFlow;
    },
    showSubsFlow() {
      return this.$store.state.navigation.showSubsFlow;
    },
  },
  async mounted() {
    await this.$eb.emit("BoxAuthanticated")



    // @media (max-width: 500px) {
    //   #cleed-frame {
    //   min-height: 100vh !important;
    //   }
    // }

    const css_all = `
     .chat-message-time {
        display: none;
     }`;
    let company_style_all = document.createElement("style");
    company_style_all.innerHTML = css_all;
    document.body.appendChild(company_style_all);

    if (
      this.$store.state.config.storeId == 41 ||
      this.$store.state.config.storeId == 26
    ) {
      const css = `
          .cleed-namespace .popup-box {
        z-index: 2147482998;
        position: fixed;
        left: 20px;
        bottom: 90px;
        width: 265px;
      }

      @media (min-width: 500px) {
       .cleed-namespace .cleed-kyolyo {
          left: 20px !important;
          width: 416px !important;
        }

      }

      .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        left: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #000;
        box-sizing: content-box !important;
      }

      .powered {
        padding-top: 28em!important;
      }

      .svg-logo {
        width: 90px;
        height: 90px;
        margin: -30px;
      }
        `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 50) {
      const css = `
          .cleed-namespace .popup-box {
        z-index: 2147482998;
        position: fixed;
        right: 90px;
        bottom: 90px;
        width: 265px;
      }

      @media (min-width: 500px) {
       .cleed-namespace .cleed-kyolyo {
          right: 90;
          width: 416px !important;
        }

      }

      .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        right: 90px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #000;
        box-sizing: content-box !important;
      }

      .powered {
        padding-top: 28em!important;
      }

      .svg-logo {
        width: 90px;
        height: 90px;
        margin: -30px;
      }
        `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 18) {
      const css = `
      @media (min-width: 500px) {
        .cleed-namespace .cleed-kyolyo {
            right: 24px;
        }
        .cleed-namespace .popup-box {
            right: 24px;
        }

        .cleed-namespace .chat-circle {
          right: 24px;
        }
      }

      .cleed-namespace .chat-circle {
        box-sizing: initial !important;

      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 18) {
      const css = `
     #popup-box {
      z-index:0;
     }
     .cleed-namespace .chat-circle {
      z-index:0;
     }
     .powered {
       padding-top: 33em!important;
     }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 20) {
      const css = `
     .cleed-namespace .cleed-kyolyo {
       border-radius: 4px;
     }

     .cleed-namespace .chat-circle {
      background-color: white;
     }

     .cleed-namespace .chat-circle {
       box-shadow: 0 0 4px 0 rgb(0 0 0 / 12%), 0 4px 12px 0 rgb(0 0 0 / 10%);
     }

     .cleed-namespace .chat-avatar {
       padding: 4px;
     }

     .powered {
       padding-top: 28em!important;
     }

     .chat-buttons:hover {
       background-color: black;
       color: white;
     }

     .svg-logo {
       margin: -19px!important;
     }

     .path-svg-logo {
       fill: black;
     }

     .cleed-namespace .chat-submit-emoji {
       top: 24px!important;
       fill: rgb(0 0 0 / 14%)!important;
     }

      .chat-box-header h1 {
        font-family: avenir next medium!important;
        font-size: 19px!important;
        padding-top: 7px!important;
        padding-right: 159px!important;
      }

      .header-box-title {
        font-family: avenir next medium!important;
        font-size: 19px!important;
        padding-top: 7px!important;
        padding-right: 159px!important;
      }

     @media (min-width: 900px) {
       .cleed-namespace .cleed-kyolyo {
          width: 375px !important;
          min-height: 250px !important;
          max-height: 586px !important;
        }
      }

      @media (max-width: 900px) {
       .cleed-namespace .popup-box {
          visibility: hidden!important;
        }
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 25) {
      const css = `
     #cookies-banner {
       bottom: 0px !important;
     }

     .cleed-namespace .header-box-title {
       max-width: 335px;
     }

     .chat-box-header {
       min-height: 80px !important;
     }

     @media (max-width: 900px) {
       .cleed-namespace .popup-box {
          visibility: hidden!important;
        }
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 35) {
      const css = `
     .cleed-namespace .chat-circle {
     background: rgb(34, 78, 66);
     z-index: 10000000000;
     }

     .powered {
       padding-top: 33em!important;
     }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 36) {
      const css = `
     .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        right: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #0f1057;
      }
      .chat-box-header h1 {
        font-family: "Letter Gothic Medium";
      }
      .powered {
        padding-top: 33em!important;
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 38) {
      const css = `
      .cleed-namespace .chat-circle {
        background: #0c244b;
      }
      .chat-box-switch-mode {
        display: none!important;
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 46) {
      const css = `
      .powered {
        padding-top: 33em!important;
      }
      .cleed-namespace .chat-circle {
        background-color: #CBC1B0;
        bottom: 105px !important;
      }
      .cleed-namespace .popup-box {
        bottom: 175px !important;
      }
      .green-circle{
        bottom: 105px !important;
      }
      .image-cropper {
        box-shadow: none!important;
      }
      .cleed-namespace .chat-buttons {
        border-color: #cbc1b0;
      }
      .chat-buttons {
        border-color: #cbc1b0;
      }
      .cleed-namespace .chat-buttons:hover {
        background-color: #cbc1b0;
      }
      .chat-buttons:hover {
        background-color: #cbc1b0;
      }
      .btn-noo-size {
        display: block;
        color: black;
        font-size: .7407407407rem;
        letter-spacing: .07em;
        line-height: 1.037037037rem;
        text-transform: uppercase;
        margin-left: 135px;
        text-decoration: underline;
        text-underline-offset: 2px;
        cursor: pointer;
        padding: 0;
        background: none;
        border: none;
        position: absolute;
        text-decoration-color: rgba(0, 0, 0,.35);
        transition: 0.2s;
      }
      .btn-noo-size:hover {
        text-decoration-color: black;
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 42) {
      const css = `
      .powered {
        padding-top: 30em!important;
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }
    // custom style from the client
    if (
      this.$store.state.config.storeId == 28 ||
      this.$store.state.config.storeId == 33 ||
      this.$store.state.config.storeId == 37
    ) {
      const css = `
      .cleed-namespace .chat-avatar {
        left: -6px!important;
      }

      .chat-avatar {
        left: -6px!important;
      }

      .cleed-namespace .chat-circle{
        box-shadow: none!important;
        -webkit-box-shadow: none!important;
      }

      @media (min-width: 500px) {
       .cleed-namespace .cleed-kyolyo {
          z-index: 2147483000;
          position: fixed;
          bottom: 11px;
          right: 11px;
          width: 416px;
          min-height: 250px;
          max-height: 704px;
          -webkit-box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
          box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
          border-radius: 8px;
          overflow: hidden;
          opacity: 1;
          height: calc(100% - 120px);
        }
      .cleed-namespace .popup-box {
       bottom: 80px;
       right: 15px;
      }
     }

     @media (max-width: 500px) {
      .cleed-namespace div.chat-circle {
        bottom: 110px!important;
        right: 7px!important;
        margin: -19px;
        border-radius: 50%;
        border-bottom-left-radius: 50%;
        border-top-left-radius: 50%;
        border-bottom-right-radius: 0%;
        border-top-right-radius: 0%;
      }
      .lex-circle {
        height: 80%;
        width: 80%;
        border-radius: 50%;
        border-bottom-left-radius: 50%;
        border-top-left-radius: 50%;
        border-bottom-right-radius: 0%;
        border-top-right-radius: 0%;
      }
      .cleed-namespace .popup-box {
        bottom: 64px;
        right: 10px;
      }
      .cleed-namespace .chat-circle{
        box-shadow: none!important;
        -webkit-box-shadow: none!important;
      }
     }

     .cleed-namespace .chat-buttons {
         padding: 8px 13px;
     }
     .cleed-namespace div.chat-circle {
       z-index: 2147482999;
       position: fixed;
       bottom: 15px;
       right: 15px;
       width: 60px;
       height: 60px;
       border-radius: 50%;
       color: #fff;
       cursor: pointer;
       background: none;
       padding: 0;
     }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 47) {
      const css = `
          .cleed-namespace .popup-box {
        z-index: 2147482998;
        position: fixed;
        left: 20px;
        bottom: 114px;
        width: 265px;
      }

      @media (min-width: 500px) {
       .cleed-namespace .cleed-kyolyo {
          left: 20px !important;
          width: 416px !important;
        }

      }

      .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 68px;
        left: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #000;
        box-sizing: content-box !important;
      }

      .cleed-namespace .green-circle-left {
        bottom: 67px !important;
      }

      .chat-box-header h1 {
        font-family: "Helvetica Neue";
      }

      .svg-logo {
        width: 90px;
        height: 90px;
        margin: -30px;
        padding: 10px;
      }

      .powered {
       padding-top: 33em!important;
     }
        `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (
      this.$store.state.config.storeId == 26 ||
      this.$store.state.config.storeId == 38 ||
      this.$store.state.config.storeId == 35 ||
      this.$store.state.config.storeId == 40 ||
      this.$store.state.config.storeId == 41 ||
      this.$store.state.config.storeId == 42 ||
      this.$store.state.config.storeId == 18 ||
      this.$store.state.config.storeId == 47 ||
      this.$store.state.config.storeId == 46 ||
      this.$store.state.config.storeId == 36 ||
      this.$store.state.config.storeId == 23 ||
      this.$store.state.config.storeId == 28 ||
      this.$store.state.config.storeId == 33 ||
      this.$store.state.config.storeId == 37 ||
      this.$store.state.config.storeId == 50
    ) {
      const css = `
     @media (min-width: 900px) {
       .cleed-namespace .cleed-kyolyo {
          width: 416px !important;
          min-height: 250px !important;
          max-height: 704px !important;
        }
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 49) {
      const css = `
      .chat-avatar {
        padding: 4px;
      }
      .chat-box-header {
        background: #1141ce !important;
      }
      .chat-box-close {
        top: 0px!important;
      }
      .chat-box-switch-mode {
        top: 0px!important;
      }
      .cleed-namespace .chat-circle {
        background-color: #1141ce;
      }
      .cleed-namespace .chat-buttons:hover {
        background-color: #1141ce;
      }
      .chat-box {
        background-color: #fff;
      }
      .chat-buttons:hover {
        background-color: #1141ce!important;
      }
      .chat-box-header h1 {
        font-family: Inter, sans-serif!important;
      }
        `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 50) {
      const css = `
      .svg-logo {
        width: 90px;
        height: 90px;
        margin: -30px;
        padding: 10px;
      }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 33) {
      const css = `
        @media (max-width: 499px) {
          .chat-message-container.left{
              display: none;
          }
          .cleed-namespace .popup-box {
              bottom: 160px;
          }
        }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 20 || this.$store.state.config.storeId == 33 || this.$store.state.config.storeId == 46) {
      const css = `
      .modal-size-container {
        display: block !important;
        position: fixed !important;
        z-index: 9999999999 !important;
        left: 0 !important;
        top: 0 !important;
        width: 100% !important;
        height: 100% !important;
        background-color: rgba(0,0,0,0.4) !important;

        font-size: initial !important;
        line-height: initial !important;
        font-weight: initial !important;
        -webkit-text-size-adjust: initial !important;
      }`;

      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 53) {
      const css = `
        .cleed-namespace .cleed-kyolyo {
          border-radius: 0;
        }
        .chat-message-time {
          display: none;
        }
     `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 54) {
      const css = `
      .cleed-namespace .cleed-kyolyo{
        z-index: 2147483650 !important;
      }
      .powered {
        padding-top: 33em!important;
      }
      .cleed-namespace .chat-circle {
        background-color: #00243e;
        bottom: 70px !important;
      }
      .cleed-namespace .popup-box {
        bottom: 145px !important;
      }
      .green-circle{
        bottom: 70px !important;
      }
      .image-cropper {
        box-shadow: none!important;
      }
      .cleed-namespace .chat-buttons {
        border-color: #00243e;
      }
      .chat-buttons {
        border-color: #00243e;
      }
      .cleed-namespace .chat-buttons:hover {
        background-color: #00243e;
      }
      .chat-buttons:hover {
        background-color: #00243e;
      }
      .btn-noo-size {
        display: block;
        color: black;
        font-size: .7407407407rem;
        letter-spacing: .07em;
        line-height: 1.037037037rem;
        text-transform: uppercase;
        margin-left: 135px;
        text-decoration: underline;
        text-underline-offset: 2px;
        cursor: pointer;
        padding: 0;
        background: none;
        border: none;
        position: absolute;
        text-decoration-color: #00243e;
        transition: 0.2s;
      }
      .btn-noo-size:hover {
        text-decoration-color: black;
      }
      @media (max-width: 499px) {
        .cleed-namespace .chat-circle {
          bottom: 80px !important;
        }

        .green-circle{
          bottom: 80px !important;
        }
      }
        `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 55) {
      const css = `
     .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        right: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #302e2e;
        .powered {
          padding-top: 33em!important;
        }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }
    if (this.$store.state.config.storeId == 59) {
      const css = `
     .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        right: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #000000;
        .powered {
          padding-top: 33em !important;
        }
        * {
          font-family: "Helvetica" !important;
        }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 57) {
      const css = `
     .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        right: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #000000;
        .powered {
          padding-top: 33em!important;
        }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 87) {
      const css = `
     .cleed-namespace .chat-circle {
        z-index:2147483000;
        position: fixed;
        bottom: 26px;
        right: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        padding: 15px;
        cursor: pointer;
        background: #AC9270;
        .powered {
          padding-top: 33em!important;
        }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }

    if (this.$store.state.config.storeId == 78) {
      const css = `

      @media (max-width: 500px) {
        .cleed-namespace .cleed-kyolyo {
          bottom: 0;
          z-index: 9999999999 !important;
        }
        .cleed-namespace .chat-circle {
          bottom: 95px !important;
        }
        .cleed-namespace .popup-box {
            bottom: 175px !important;
        }
      }

      @media (min-width: 500px) {
        .cleed-namespace .cleed-kyolyo {
          bottom: 60px !important;
        }
      }

      .cleed-namespace .chat-circle {
          z-index: 2147483000;
          position: fixed;
          bottom: 65px;
          right: 20px;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          color: white;
          padding: 15px;
          cursor: pointer;
          background: #00243e;
        }
        .powered {
          padding-top: 33em!important;
        }
        .green-circle{
          bottom: 65px !important;
        }
        .cleed-namespace .popup-box {
          bottom: 145px;
        }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }


    if (this.$store.state.config.storeId == 79) {
      const css = `
        .cleed-namespace .chat-circle {
          z-index:2147483000;
          position: fixed;
          bottom: 26px;
          right: 20px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          color: white;
          padding: 15px;
          cursor: pointer;
          background: #034155;
          .powered {
            padding-top: 33em!important;
          }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }
    if (this.$store.state.config.storeId == 88) {
      const css = `
        .cleed-namespace .chat-circle {
          z-index:2147483000;
          position: fixed;
          bottom: 26px;
          right: 20px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          color: white;
          padding: 15px;
          cursor: pointer;
          background: #1e0096;
          .powered {
            padding-top: 33em!important;
          }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }
    if (this.$store.state.config.storeId == 89) {
      const css = `
        .cleed-namespace .chat-circle {
          z-index:2147483000;
          position: fixed;
          bottom: 26px;
          right: 20px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          color: white;
          padding: 15px;
          cursor: pointer;
          background: #c89603;
          .powered {
            padding-top: 33em!important;
          }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }
    if (this.$store.state.config.storeId == 90) {
      const css = `
        .cleed-namespace .chat-circle {
          z-index:2147483000;
          position: fixed;
          bottom: 26px;
          right: 20px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          color: white;
          padding: 15px;
          cursor: pointer;
          background: #ff0032;
          .powered {
            padding-top: 33em!important;
          }
      `;
      let company_style = document.createElement("style");
      company_style.innerHTML = css;
      document.body.appendChild(company_style);
    }
  },
};

if (specs._CUSTOM_CIRCLE) {
  obj.components["chat-circle"] = Circle_lexception;
} else {
  obj.components["chat-circle"] = ChatCircle;
}
export default obj;
</script>

<style>
@import "./assets/cleed-container.css";
</style>
